import { AfterViewInit, ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Params, RouterLink } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { TruncateDirective } from '../../directives/truncate.directive';

export interface UiBreadCrumbItem {
  name: string;
  route?: string;
  queryParams?: Params | null;
  fragment?: string;
}

@Component({
  selector: 'ui-header-with-breadcrumbs',
  standalone: true, imports: [AsyncPipe, NgForOf, NgIf, RouterLink, TranslatePipe, TruncateDirective],
  templateUrl: './ui-header-with-breadcrumbs.component.html',
  styleUrl: './ui-header-with-breadcrumbs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiHeaderWithBreadcrumbsComponent implements AfterViewInit {

  @Input() public selectBreadcrumbs: UiBreadCrumbItem[] = [];

  public documentDirection$: BehaviorSubject<'ltr' | 'rtl'> = new BehaviorSubject<'ltr' | 'rtl'>('ltr');

  public ngAfterViewInit(): void {
    const documentDirection = (document.documentElement.getAttribute('dir') as 'ltr' | 'rtl') || 'ltr';
    this.documentDirection$.next(documentDirection);
  }
}
